import { getEventLink, getConferenceLocation } from 'theme/utils/generic-helpers'

const getTicketsMeta = (tickets, ticketsLink) => {
  const ticketsMeta = tickets.map((ticket) => {
    const [startYear, startMonth, startDay] = ticket.data.Start_Time.split('-')

    const startDate = new Date(Date.UTC(startYear, startMonth - 1, startDay.split('T')[0])).getTime()
    const now = Date.now()
    const availability = startDate < now ? 'InStock' : 'PreOrder'
    return {
      '@type': 'Offer',
      name: ticket.data.Access + ' (' + ticket.data.Delivery + ')',
      price: ticket.data.Price,
      priceCurrency: ticket.data.Currency,
      validFrom: ticket.data.Start_Time,
      url: ticketsLink,
      availability: 'https://schema.org/' + availability,
    }
  })
  return ticketsMeta
}

const getVenueMeta = (venues, conferenceLink) => {
  // get the Conference Venue information
  const schemaLocation = [
    {
      '@type': 'VirtualLocation',
      url: conferenceLink,
    },
  ]
  let eventAttendanceMode = 'Online'
  venues &&
    venues.map((venue) => {
      if (venue.data.Venue_Type !== 'Online') {
        eventAttendanceMode = 'Offline'
        schemaLocation.push({
          '@type': 'Place',
          name: venue.data.Name,
          address: {
            '@type': 'PostalAddress',
            streetAddress: venue.data.Venue_Address,
            addressLocality: venue.data.Venue_City,
            postalCode: venue.data.Venue_Type === 'In-Person' && venue.data.Post_Code,
            addressCountry: venue.data.Venue_Type === 'In-Person' && venue.data.Country,
          },
        })
      }
    })
  return {
    schemaLocation,
    eventAttendanceMode: 'https://schema.org/' + eventAttendanceMode + 'EventAttendanceMode',
  }
}

export const getVenueGeoLocation = (venues) => {
  if (!venues) return {}
  const venue = venues.filter((venue) => venue.data.Venue_Type === 'In-Person')[0]
  if (venue)
    return {
      region: venue.data.Country,
      placename: venue.data.Venue_City,
      position: venue.data.Venue_Latitude + ';' + venue.data.Venue_Longitude,
    }
  else return null
}

export const getSchemaData = (conference, tickets, venues, metaDescription) => {
  const conferenceLocation = getConferenceLocation(conference)
  let availableTicketsMeta
  if (tickets.length > 0) {
    availableTicketsMeta = getTicketsMeta(
      tickets,
      getEventLink(conference.data.Conference_Id, conferenceLocation),
    )
  }
  const { schemaLocation, eventAttendanceMode } = getVenueMeta(
    conference.data.Venue,
    getEventLink(conference.data.Conference_Id, conferenceLocation),
  )
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: conference.data.Conference_Name + ' ' + conference.data.Year,
    description: metaDescription,
    startDate: conference.data.Conference_Start_Date,
    endDate: conference.data.Conference_End_Date,
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: eventAttendanceMode,
    location: schemaLocation,
    offers: availableTicketsMeta,
    image: conference.data.Meta_Home_Url || 'https://uxdx.com/images/uxdxMetaCard.jpg',
  }
  return schemaData
}
